import type { JSX } from "react";
import { cn } from "./cn";

export interface Tab {
  readonly id: string;
  readonly label: string;
}

export interface TabBarProps {
  readonly tabs: readonly Tab[];
  readonly activeTab: string;
  readonly onTabChange: (tabId: string) => void;
}

/**
 * A horizontal tab bar with underline-style active indicator.
 * Uses explicit id/label pairs for reliable matching.
 * Used in contacts, companies, and other plugin detail views.
 */
export function TabBar({ tabs, activeTab, onTabChange }: TabBarProps): JSX.Element {
  return (
    <div className="flex gap-4 border-b border-edge">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            className={cn(
              "bg-transparent border-none py-2 text-sm cursor-pointer",
              isActive ? "text-accent border-b-2 border-b-accent" : "text-content-tertiary",
            )}
            type="button"
            onClick={() => { onTabChange(tab.id); }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
